import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "../../statusHTTP";

const PREFIXO = 'diagnostico';

export const buscarAnaliseGeral = async (params) => {
  const url = `/${PREFIXO}/slow-no-moving/histogramas`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.histogramas;
}

export const buscarAnalisePorSegmentos = async (params) => {
  const url = `/${PREFIXO}/slow-no-moving/segmentos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.segmentos;
}

export const buscarAnalisePorFornecedores = async (params) => {
  const url = `/${PREFIXO}/slow-no-moving/fornecedores`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.fornecedores;
}

export const buscarAnalisePorProdutos = async (params) => {
  const url = `/${PREFIXO}/slow-no-moving/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}
